import EventService from "../../services/EventService";
// import { indexById } from "../../components/Utils";
import { addOther } from "@/utils/Item";

export const namespaced = true;


export const state = {
    loading: -1,  // Initial no-load state
    meetings: [],
    byId: {}
};

export const mutations = {
    SET_LOADING(state, percent) {
        state.loading = percent;
    },
    SET_MEETINGS(state, meetings) {
        state.meetings = meetings;
    },
    SET_BYID(state, indexed) {
        state.byId = indexed;
    },
    ADD_MEETING(state, meeting) {
        state.meetings.push(meeting);
    },
    REMOVE_MEETING(state, meeting_id) {
        console.log("REMOVE_MEETING", meeting_id);
        const index = state.meetings.findIndex(meeting => meeting.id === meeting_id);
        if (index !== -1) { 
            state.meetings.splice(index, 1); 
        }
    }
};

export const actions = {
    async fetchMeetings(context, attendee) {
        console.log("fetchMeetings:Attendee:", attendee);
        context.commit('SET_LOADING', 0);
        return EventService.getMeetings()
            .then(response => {
                context.commit('SET_LOADING', 50);
                let data = response.data.map(addOther(attendee));
                context.commit('SET_MEETINGS', data);
                // context.commit('SET_BYID', indexById(response.data));
            })
            .catch(error => {
               console.log('getMeetings failed: ', error.message)
               context.commit('SET_LOADING', 101); // Error state
               throw new Error('Could not load meetings');
            })
            .then(() => {
                context.commit('SET_LOADING', 100);
            });
    },
    reset(context) {
        context.commit('SET_LOADING', -1);
        context.commit('SET_MEETINGS', []);
        context.commit('SET_BYID', {});
    },
    sendPrivate(context, slot_id) {
        return EventService.postPrivate(slot_id)
            .then(response => {
                // Should receive a meeting object that can be added to the list
                console.log("sendPrivate data", response.data);
                context.commit('ADD_MEETING', response.data);
            });
    },
    sendAvailable(context, slot_id) {
        return EventService.postAvailable(slot_id)
            .then(response => {
                // Should receive a meeting_id that can be removed from the list
                let meeting_id = response.data.meeting_id;
                console.log("sendAvailable data", response.data);
                if (meeting_id) {
                    context.commit('REMOVE_MEETING', meeting_id);
                }
            });
    },
};

export const getters = {
    meetingsByDay: (state) => {
        const meetings = []
        for (let i = 0, max = state.meetings.length; i < max; i++) {
            let meeting = state.meetings[i];

            if (! (meeting.day in meetings)) {
                meetings[meeting.day] = [];
            }

            meetings[meeting.day].push(meeting);
        }
        return meetings;
    },
    meetingById: (state) => (meeting_id) => {
        return state.meetings.find(meeting => meeting.id == meeting_id);
    },
    /* All the confirmed meetings */
    confirmed: (state) => {
        return state.meetings.filter(meeting => (
            (meeting.confirmed_at !== null) &&
            (meeting.deleted_at === null)
        ));
    },
    deleted: (state) => {
        return state.meetings.filter(meeting => (
            (meeting.deleted_at !== null)
        ));
    },
    
    /* All the 1:1 meetings not deleted (1:1 == 'private' ones) */
    visible: (state) => {
        return state.meetings.filter(meeting => (
            (meeting.deleted_at === null) &&
            (meeting.attendee_id !== null)
        ));
    },
    /* Everything that isn't 'private' - Used by the meeting filters */
    all: (state) => {
        return state.meetings;
        // return state.meetings.filter(meeting => (
        //     (meeting.attendee_id !== null)
        // ));
    },
    
    /* Unconfirmed meetings where the attendee_id is the receiving Attendee, rather than the booker */
    pendingForId: (state) => (attendee_id) => {
        return state.meetings.filter(meeting => (
            (meeting.attendee_id == attendee_id) &&
            (meeting.confirmed_at === null) &&
            (meeting.deleted_at === null)
        ));
    },
    /* Unconfirmed meetings where the attendee_id is the Booker, rather than the attendee */
    pendingFromId: (state) => (attendee_id) => {
        return state.meetings.filter(meeting => (
            (meeting.attendee_id !== null) &&
            (meeting.booker_id == attendee_id) &&
            (meeting.confirmed_at === null) &&
            (meeting.deleted_at === null)
        ));
    },
    
};